import { types as sdkTypes } from '../util/sdkLoader';

// Action types
export const FETCH_TIME_SLOTS_REQUEST = 'app/EditListingPage/FETCH_TIME_SLOTS_REQUEST';
export const FETCH_TIME_SLOTS_SUCCESS = 'app/EditListingPage/FETCH_TIME_SLOTS_SUCCESS';
export const FETCH_TIME_SLOTS_ERROR = 'app/EditListingPage/FETCH_TIME_SLOTS_ERROR';

// Reducer == default export
const initialState = {
  monthlyTimeSlots: {},
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    // 3x time slot reducers borrowed from ListingPage.duck.js.
    case FETCH_TIME_SLOTS_REQUEST: {
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [payload]: {
          ...state.monthlyTimeSlots[payload],
          fetchTimeSlotsError: null,
          fetchTimeSlotsInProgress: true,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_SUCCESS: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          timeSlots: payload.timeSlots,
        },
      };
      return { ...state, monthlyTimeSlots };
    }
    case FETCH_TIME_SLOTS_ERROR: {
      const monthId = payload.monthId;
      const monthlyTimeSlots = {
        ...state.monthlyTimeSlots,
        [monthId]: {
          ...state.monthlyTimeSlots[monthId],
          fetchTimeSlotsInProgress: false,
          fetchTimeSlotsError: payload.error,
        },
      };
      return { ...state, monthlyTimeSlots };
    }

    default:
      return state;
  }
}

// Action creators
export const fetchTimeSlotsRequest = monthId => ({
  type: FETCH_TIME_SLOTS_REQUEST,
  payload: monthId,
});
export const fetchTimeSlotsSuccess = (monthId, timeSlots) => ({
  type: FETCH_TIME_SLOTS_SUCCESS,
  payload: { timeSlots, monthId },
});
export const fetchTimeSlotsError = (monthId, error) => ({
  type: FETCH_TIME_SLOTS_ERROR,
  error: true,
  payload: { monthId, error },
});

// This file's 2 thunks support EditListingPage's `loadData()`, and video conferencing page's direct use.
// They're adapted from ListingPage.duck.js, with inline logic replacing use of `timeSlotsRequest()` which
// would perform an SDK call for slots.
export const fetchTimeSlots = (listingId, start, end, timeZone) => (dispatch, getState, sdk) => {
  // YYYY-MM. We *could* use this and implement our own action but as there
  // are no server calls it doesn't seem to gain us much.
  // const monthId = monthIdStringInTimeZone(start, timeZone);

  // Off the shelf pages that use the timeSlot-dependent date/time components fire
  // an SDK call to get the slots like this. We're replacing this with a DIY counterpart
  // below for now.
  // dispatch(fetchTimeSlotsRequest(monthId));

  let timeSlots = [];
  let currentDate = start;
  while (currentDate < end && timeSlots.length < 10001) {
    /** @var {Date} currentDate */
    let nextDate = new Date(currentDate.getTime() + 60 * 60 * 1000);
    timeSlots.push({
      id: new sdkTypes.UUID('dummyTime'), // Pseudo-timeSlots. We're *replacing* the SDK lookup here so there are no real slot IDs.
      type: 'timeSlot',
      attributes: {
        type: 'time-slot/time',
        seats: 999,
        start: currentDate,
        end: nextDate,
      },
    });

    currentDate = nextDate;
  }

  // For now, "short circuit" some of the reducer cycle to ignore "month ID"
  // and skip the SDK time slot lookup. It seems so far like Flex and hourly
  // slots without seat limits are not compatible.
  dispatch(fetchTimeSlotsSuccess(undefined, timeSlots));
};

export const fetchMonthlyTimeSlots = (dispatch, listing) => {
  const hasWindow = typeof window !== 'undefined';
  const attributes = listing.attributes;
  // Listing could be ownListing entity too, so we just check if attributes key exists
  const hasTimeZone =
    attributes && attributes.availabilityPlan && attributes.availabilityPlan.timezone;

  // Fetch time-zones on client side only.
  if (hasWindow && listing.id && hasTimeZone) {
    const tz = listing.attributes.availabilityPlan.timezone;
    const nextBoundary = findNextBoundary(tz, new Date());

    const nextMonth = nextMonthFn(nextBoundary, tz);
    const nextAfterNextMonth = nextMonthFn(nextMonth, tz);

    return Promise.all([
      dispatch(fetchTimeSlots(listing.id, nextBoundary, nextMonth, tz)),
      dispatch(fetchTimeSlots(listing.id, nextMonth, nextAfterNextMonth, tz)),
    ]);
  }

  // By default return an empty array
  return Promise.all([]);
};
